import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  root: {
    marginTop: 7
  },
  emptyCircle: {
    flexShrink: 0,
    width: 18,
    height: 18,
    backgroundColor: 'transparent',
    border: `1px solid ${theme.grey4}`,
    borderRadius: '50%'
  }
}));
